module.exports = __webpack_public_path__ + "static/media/document_upload_icon.4b7060a4.svg";